import { useState } from 'react';
import { LItem, Pagination } from "components";
import { Link } from 'react-router-dom';
import { DocumentTextIcon } from '@heroicons/react/24/outline';

function ListLoans({ loans }) {

    loans = loans.sort((a, b) => Date.parse(b.date) - Date.parse(a.date));

    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(10);
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = loans?.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(loans?.length / recordsPerPage);

    return (
        <div className="mt-2">
            <div className="overflow-hidden rounded-xl border border-gray-200 dark:border-white/[.08] bg-white dark:bg-gray-900 shadow-sm">
                <div className="overflow-x-auto">
                    <table className="min-w-full">
                        <thead>
                            <tr className="border-b border-gray-100 dark:border-white/[.06] bg-gray-50/70 dark:bg-white/[.02]">
                                <th scope="col" className="px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">Loan Type</th>
                                <th scope="col" className="px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">Amount</th>
                                <th scope="col" className="px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">Applied On</th>
                                <th scope="col" className="px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">Stage</th>
                                <th scope="col" className="px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">Action</th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-gray-50 dark:divide-white/[.04]">
                            {currentRecords && currentRecords.length > 0 ? (
                                currentRecords.map(item => (
                                    <LItem key={item?._id} item={item} />
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="px-5 py-16 text-center">
                                        <DocumentTextIcon className="mx-auto h-10 w-10 text-gray-300 dark:text-gray-600 mb-3" />
                                        <p className="text-sm font-medium text-gray-500 dark:text-gray-400">No loan applications yet</p>
                                        <p className="mt-1 text-xs text-gray-400 dark:text-gray-500">
                                            Ready to get started?{' '}
                                            <Link to="/loans" className="text-gold-600 hover:text-gold-500 font-medium">Apply for a loan</Link>
                                        </p>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {currentRecords && currentRecords.length > 0 && (
                    <div className="border-t border-gray-100 dark:border-white/[.06]">
                        <Pagination
                            nPages={nPages}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            length={loans?.length}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}

export default ListLoans
